import P2Regular from 'components/typography/P2Regular';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the safety point of a revision.
 */
export default function SafetyPointColumn({ data: { safetyPointPretty } }: { data: RevisionRow }) {
  return <P2Regular lineClamp={3}>{safetyPointPretty}</P2Regular>;
}
